











































































































import {Vue, Component, Prop} from 'vue-property-decorator/lib/vue-property-decorator';
import WipTicket from "@/domainObjects/wip/WipTicket";
import CustomDatePicker from "@/view/shared-components/CustomDatePicker.vue";

@Component({
    components: {CustomDatePicker},
})

export default class WipProductInformation extends Vue {
    @Prop({required: true}) wipTicket!: WipTicket;
    @Prop({required: true}) type!: String;
}
